import React from 'react';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Skeleton as Skeleton$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Skeleton = (_a) => {
  var _b = _a, {
    variant = "rectangle",
    width = "100%",
    height = "100%",
    lines = 0
  } = _b, props = __objRest(_b, [
    "variant",
    "width",
    "height",
    "lines"
  ]);
  return lines ? /* @__PURE__ */ React.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, Array.from({ length: lines }).map((_val, index) => /* @__PURE__ */ React.createElement(Skeleton$1, __spreadProps(__spreadValues({}, props), {
    key: index,
    style: {
      width,
      height
    }
  })))) : /* @__PURE__ */ React.createElement(Skeleton$1, __spreadProps(__spreadValues({}, props), {
    variant,
    style: {
      width,
      height
    }
  }));
};
Skeleton.displayName = "Skeleton";

export { Skeleton };
//# sourceMappingURL=Skeleton.es.js.map
